import type { Route } from './types'
import fs from 'node:fs'
import path from 'node:path'

export function generateRouteTypes(routes: Route[], outputDir: string): void {
  const lines = [
    '// Auto-generated by STX - do not edit',
    'declare module "stx/routes" {',
    '  interface RouteMap {',
  ]

  for (const route of routes) {
    const paramEntries: string[] = []
    for (const p of route.params) {
      const type = route.pattern.includes(`:${p}*`) ? 'string[]' : 'string'
      paramEntries.push(`${p}: ${type}`)
    }
    const paramsStr = paramEntries.join('; ')
    lines.push(`    '${route.pattern}': { ${paramsStr} }`)
  }

  lines.push('  }', '}', '')

  fs.mkdirSync(outputDir, { recursive: true })
  fs.writeFileSync(path.join(outputDir, 'route-types.d.ts'), lines.join('\n'))
}

/**
 * Generate a route manifest file (.stx/routes.ts).
 *
 * Produces a TypeScript module exporting the full route array with patterns,
 * file paths, params, and layout references. Similar to Nuxt's .nuxt/routes.mjs.
 */
export function generateRouteManifest(routes: Route[], outputDir: string, pagesDir: string): void {
  const cwd = process.cwd()
  const relativePages = path.relative(cwd, pagesDir)

  // Filter out non-page files (components, layouts, partials)
  const excludeDirs = ['components', 'layouts', 'partials']
  const pageRoutes = routes.filter(r =>
  !excludeDirs.some(dir => r.pattern.startsWith(`/${dir}/`) || r.pattern === `/${dir}`),
)

const lines = [
  '// Auto-generated by stx — do not edit',
  `// Source: ${relativePages || 'pages'}/`,
  '',
  'export const routes = [',
]

for (const route of pageRoutes) {
  const relFile = path.relative(cwd, route.filePath).replace(/\\/g, '/')
  const params = JSON.stringify(route.params)
  const layoutStr = route.layout
    ? `, layout: '${path.relative(cwd, route.layout).replace(/\\/g, '/')}'`
    : ''
  lines.push(`  { pattern: '${route.pattern}', filePath: '${relFile}', isDynamic: ${route.isDynamic}, params: ${params}${layoutStr} },`)
}

lines.push('] as const', '')
lines.push('export type RouteName = typeof routes[number][\'pattern\']', '')

fs.mkdirSync(outputDir, { recursive: true })
fs.writeFileSync(path.join(outputDir, 'routes.ts'), lines.join('\n'))
}
